import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { CustomProductsService } from 'src/app/modules/custom-landing/custom-products/custom-products.service';
import { QuoteSelectProductsEditBidComponent } from 'src/app/shared/components/quote-select-products-edit-bid/quote-select-products-edit-bid.component';
import { NgIf, NgFor, DecimalPipe, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { I18nModule } from '@spartacus/core';
@Component({
    selector: 'app-quote-select-products-edit-confirm-bid',
    templateUrl: './quote-select-products-edit-confirm-bid.component.html',
    styleUrls: ['./quote-select-products-edit-confirm-bid.component.scss'],
    imports: [NgIf, NgFor, FormsModule, DecimalPipe, DatePipe, I18nModule]
})
export class QuoteSelectProductsEditConfirmBidComponent implements OnInit {
  @Input() finalQPFromDate:any;
  @Input() finalQPToDate
  private modalRef: NgbModalRef;
  div1: boolean = true;
  activeTab = 'none';
  priceTab = 'none';
  COI: boolean = false;
  ITB: boolean = false;
  OpenNegotiation: boolean = true;
  @Input() parameter: any;
  @Input() multipleProduct: any;
  @Input() tabName: any;
  @Input() materialFixedPrice1: number;
  @Input() materialIndexPrice1: number;
  @Input() materialFixedPrice2: number;
  @Input() materialIndexPrice2: number;
  @Input() price: any;
  @Input() indexValue: any;
  productInfo: any;
  priceVal: any;
  tabValue: any;
  additionalTerms: any;
  requestParams: any;
  reqTenderEntries: any = [];
  combinedchildlist:any = [];
  dupData:any
  enableLoader: boolean = false;
  confirmTxt: string = null;

  constructor(private router: Router,private customProductService: CustomProductsService,public activeModal: NgbActiveModal, private Modal: NgbModal,
    private customProductsService: CustomProductsService, private toastrService: ToastrService) { }

  ngOnInit(): void {
    this.customProductsService.getConfirmtxt().subscribe((txt)=>{
      this.confirmTxt = txt;
    })
    console.log(this.parameter);
    this.productInfo = this.parameter;
    this.additionalTerms=this.multipleProduct?this.multipleProduct.buyerRemarks:'';
    if(this.multipleProduct.groupTenders){
      for(let a of this.multipleProduct.groupTenders){
        this.combinedchildlist.push(...a?.childList)
        for(let  ind of this.multipleProduct.IndividualTenders){
          if(ind.pricingOptionsEnum[0].pricingOptions=='INDEX_PRICE'){
           ind.premDiscount=ind.premiumDiscount.value
          }else{
            ind.relPrice=ind.relativePrice.value
          }
        }
        this.multipleProduct.combinedchildlist=[...this.combinedchildlist,...this.multipleProduct.IndividualTenders]
      }
    } 
    console.log(this.multipleProduct.combinedchildlist,'bt')
    this.tabValue = this.tabName;
    if(this.multipleProduct.groupTenders){
      this.multipleProduct.combinedchildlist.map((val)=>{
        if(val.materialIndexPrice1 || val.materialFixedPrice1 || val.relativePrice ||val.price || val.premiumDiscount){
          this.reqTenderEntries.push({
            "dischargePortDetails":val.isDischargePortUnrestricted==true?val.dischargePortDetails:'',
            "entryNumber": val.entryNumber,
           "finalQPFromDate":val.isQuotationPeriodUnrestricted==true || val.isQPMultipleChoicesSelected == true?val.finalQPFromDate:'',
            "finalQPToDate":val.isQuotationPeriodUnrestricted==true || val.isQPMultipleChoicesSelected == true?val.finalQPToDate:'',
              "pricingOptionsEnum": [
                  {
                    "pricingOptions":  val.pricingOptionsEnum[0].pricingOptions,
                    "qpMultipleChoices": val.pricingOptionsEnum[0].qp
                  }
                ],
              "productCode":  val.productCode,
              "qpMultipleChoices": val.pricingOptionsEnum[0].qp,
              "quantity": val.minimumQuantity && val.maximumQuantity?val.Quantity: val.quantityshw ? parseInt(val.quantityshw):val.quantity,
              // val.minimumQuantity && val.maximumQuantity?val.Quantity:val.quantity,
            //   [val.priceTab=='FIXED_PRICE'?'relativePrice':'premiumDiscount']: {
            //     "currencyIso": "USD",
            //     "value":val.priceTab=='FIXED_PRICE' && this.multipleProduct.commodityType=='IO' ||this.multipleProduct.commodityType=='CC' ? val.materialFixedPrice1 : val.materialIndexPrice1,
            //  },
            [val.pricingOptionsEnum[0].pricingOptions=='FIXED_PRICE'? 'relativePrice' : 'premiumDiscount']: {
              "currencyIso": "USD",
              "value":val.pricingOptionsEnum[0].pricingOptions=='FIXED_PRICE'?val.relPrice:val.premDiscount,
            },
            })
        }     
      }) 
    }
    else{
      this.productInfo.map((val) => {
        this.reqTenderEntries.push({
          "dischargePortDetails":val.isDischargePortUnrestricted==true?val.dischargePortshw:'',
          "entryNumber": val.entryNumber,
          "finalQPFromDate":(val.isQuotationPeriodUnrestricted==true || val.isQPMultipleChoicesSelected == true)?val.finalQPFromDate:'',
          "finalQPToDate":(val.isQuotationPeriodUnrestricted==true || val.isQPMultipleChoicesSelected == true)?val.finalQPToDate:'',
          "quantity": val.minimumQuantity && val.maximumQuantity?val.Quantity: val.quantityshw ? parseInt(val.quantityshw):val.quantity,
          "pricingOptionsEnum": [
            {
              "pricingOptions": val.pricingOptionsEnum[0].pricingOptions,
              "qpMultipleChoices": val.pricingOptionsEnum[0].qp
            }
          ],
          "productCode": val.productCode,
          "qpMultipleChoices": val.pricingOptionsEnum[0].qp,
          [val.pricingOptionsEnum[0].pricingOptions=='FIXED_PRICE'?'relativePrice':'premiumDiscount']: {
            "currencyIso": "USD",
            "value":val.pricingOptionsEnum[0].pricingOptions=='FIXED_PRICE'? this.multipleProduct.commodityType=='CC'?val.relativePrice.value:val.relPrice :  this.multipleProduct.commodityType=='CC'?val.premiumDiscount?.value:val.premDiscount,
            //"dischargePortDetails":val.isDischargePortUnrestricted==true?val.dischargePortDetails:''
         }
        })
      })
    }
    
  }
  backToPlacebid(): any {
    this.activeModal.close();
   
    const ModalRef = this.Modal.open(QuoteSelectProductsEditBidComponent, { centered: true, size: 'md' });
    this.indexValue = this.parameter.length - 1;
    ModalRef.componentInstance.indexValue = this.indexValue;
    ModalRef.componentInstance.index = this.parameter;
    ModalRef.componentInstance.code = this.multipleProduct;
    this.dupData=this.multipleProduct.combinedTenders.filter((x)=>x.productCode==this.parameter[this.indexValue].productCode && x.pricingOptionsEnum[0].pricingOptions==this.parameter[this.indexValue].pricingOptionsEnum[0].pricingOptions)
    console.log(this.dupData,'duplicates')
    for (let i = this.indexValue; i > 0; i--)
    {
      if(this.dupData.length>1){
        for(let duplicateData of this.dupData){
          if(duplicateData.childList==undefined){
      if (duplicateData.productCode == this.parameter[i-1].productCode)
        {
          ModalRef.componentInstance.disabled=true;
        console.log("Last index:" , i);
        console.log("Last duplicate item: ", this.parameter[i].productCode);
        }
      }
      }
    }
      }
      if(this.parameter[this.indexValue].minimumQuantity && this.parameter[this.indexValue].maximumQuantity){ 
        ModalRef.componentInstance.quantity=this.parameter[this.indexValue].Quantity
         }
    
    if (this.productInfo) {
      ModalRef.componentInstance.tabName = this.tabValue;
      if (this.multipleProduct.combinedTenders[this.indexValue].pricingOptionsEnum[0].pricingOptions == 'FIXED_PRICE') {
        ModalRef.componentInstance.price = this.multipleProduct.combinedTenders[this.indexValue].relativePrice.value;
        // ModalRef.componentInstance.materialFixedPrice2 =this.multipleProduct.combinedTenders[this.indexValue].relPrice;

      }
      if (this.multipleProduct.combinedTenders[this.indexValue].pricingOptionsEnum[0].pricingOptions == 'INDEX_PRICE') {
         ModalRef.componentInstance.indexPrice = this.multipleProduct.combinedTenders[this.indexValue].premiumDiscount.value;
        // ModalRef.componentInstance.materialFixedPrice2 =this.multipleProduct.combinedTenders[this.indexValue].premiumDiscount;
      }
    }
  
    
    if(this.parameter[this.indexValue].pricingOptionsEnum[0]?.qp){
      ModalRef.componentInstance.defaultValue =  this.parameter[this.indexValue]?.pricingOptionsEnum[0]?.qp[0]?.description;
      if( this.parameter[this.indexValue]?.pricingOptionsEnum[0]?.qp[0]?.description == 'Fixed QP'){
        ModalRef.componentInstance.displayFixedQPSection = true;
        this.parameter[this.indexValue].finalQPFromDate = this.finalQPFromDate  ? this.finalQPFromDate : this.parameter[this.indexValue].finalQPFromDate;
        this.parameter[this.indexValue].finalQPToDate = this.finalQPToDate ? this.finalQPToDate : this.parameter[this.indexValue].finalQPToDate;
      }else{
        ModalRef.componentInstance.displayFixedQPSection =false;
      }   
    }
   
    if(this.parameter[this.indexValue].isQuotationPeriodUnrestricted==true){
      this.parameter[this.indexValue].finalQPFromDate = this.finalQPFromDate  ? this.finalQPFromDate : this.parameter[this.indexValue].finalQPFromDate;
      this.parameter[this.indexValue].finalQPToDate = this.finalQPToDate ? this.finalQPToDate : this.parameter[this.indexValue].finalQPToDate;
   }
  }
  submitBid(): any {
   
    // if(this.parameter[this.indexValue].isQuotationPeriodUnrestricted==false){
    //   delete this.reqTenderEntries.finalQPFromDate
    //   delete this.reqTenderEntries.finalQPToDate
    // }
    this.requestParams = {
      "quoteAction": "EDIT_BID",
      "tender": {
        "buyerRemarks": this.additionalTerms,
        "quoteCode": this.multipleProduct.quoteCode,
        "tenderEntries": this.reqTenderEntries
      }
    }
    for (let row of this.reqTenderEntries) {
      if (this.multipleProduct.commodityType == 'IO') {
        if (row.premiumDiscount){
          if (row.premiumDiscount?.value == '' || row.premiumDiscount?.value == undefined) {
            row.premiumDiscount.value = 0;
          }
        }
      }
      if(row.pricingOptionsEnum[0].qpMultipleChoices){
        if(row.pricingOptionsEnum[0].qpMultipleChoices[0]?.description!='Fixed QP'){
          delete row.finalQPToDate;
          delete row.finalQPFromDate;
        }
      }

    }
    console.log(this.requestParams);
    this.enableLoader = true;
    this.customProductsService.submitTender(this.requestParams).subscribe(resp => {
      if ( resp.status=== 'BID_PLACED') {
        this.enableLoader = false;
        this.toastrService.show(resp.status);
        this.activeModal.close();
        this.customProductService.bidPlaced = true;
        const currentUrl = this.router.url;
          if (currentUrl === '/quotes/myquotes') {
            this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
              this.router.navigate([currentUrl]);
          });
          }else{
            this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
              this.router.navigate([currentUrl] );
            });
          }
      } else {
        this.enableLoader = false;
        this.toastrService.show(resp.status?resp.status:"Sorry something went wrong!");
      }
    },
      err => {
        this.enableLoader = false;
        this.activeModal.close();
        this.toastrService.show(err?.error.errors?err.error.errors[0].message:'Something went wrong while submitting the tender, please contact support team');
      })
  }
  getDate(date){
    if(date){
      var formateDate = new Date(date).getDate() + '/' + (new Date(date).getMonth() + 1) + '/' + new Date(date).getFullYear();
      return formateDate;
    }
    else{
      return '';
    }
  }
  formatQPDates(data){
    return this.customProductService.formatQPDates(data);
  }
  getPricingBasisBasedOnOption(pricingOption,description){
    return this.customProductService.getPricingBasisBasedOnOption(pricingOption,description)
  }
}
